import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#1a1400] py-12 px-4" data-id="element-206">
      <div className="max-w-5xl mx-auto" data-id="element-207">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-208">
          <div data-id="element-209">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-210">
              +3.000
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-211">
              docentes confían
            </div>
          </div>
          <div data-id="element-212">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-213">12</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-214">
              Tomos completamente listos
            </div>
          </div>
          <div data-id="element-215">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-216">
              4.9/5
            </div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-217">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-218">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-219">🌍</div>
            <div className="text-[#FFD700] text-sm font-semibold mt-1" data-id="element-220">
              Todo el mundo hispanohablante
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-221">
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-222">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-223">
              MG
            </div>
            <div data-id="element-224">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-225">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-226">
                "Organicé todo el año en una tarde"
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-227">
                — Mariela G. | Docente de Música — Educación Primaria / Básica
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-228">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-229">
              LP
            </div>
            <div data-id="element-230">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-231">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-232">
                "Mis clases de secundaria por fin enganchan"
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-233">
                — Laura P. | Docente de Música — Educación Secundaria / Media
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#FFD700]/20 rounded-xl p-4" data-id="element-234">
            <div className="w-10 h-10 rounded-full bg-[#FFD700]/20 flex items-center justify-center text-[#FFD700] font-black text-sm flex-shrink-0" data-id="element-235">
              RM
            </div>
            <div data-id="element-236">
              <div className="text-[#FFD700] text-xs mb-1" data-id="element-237">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-238">
                "Nunca más improvisé un acto escolar"
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-239">
                — Roberto M. | Docente de Música — Primaria / Básica y
                Secundaria / Media
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}